// extracted by mini-css-extract-plugin
export var editButton = "_l2-0";